export const GAME_CARD_ID_PREFIX = 'game-card-';

export const NUMBERED_GAMES_TYPE = 'numberedGames';
